import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Layout, Menu, Badge } from "antd";
import { useTranslation } from "react-i18next";
import Logo from "../Images/logistics.png";
import {
  AppstoreOutlined,
  UserOutlined,
  GiftOutlined,
  TagsOutlined,
  ApartmentOutlined,
  ShoppingCartOutlined,
  ShopOutlined,
  BarChartOutlined,
  InboxOutlined,
  BlockOutlined,
} from "@ant-design/icons";
import "../Styles/Sidebar.css";

const { Sider } = Layout;

const Sidebar = ({ collapsed, onCollapse, cartCount }) => {
  const { t } = useTranslation();
  const location = useLocation();

  const getOpenKeysFromPath = (path) => {
    const keys = [];
    if (path === "/Reports" || path === "/CategoryProductReport") {
      keys.push("reports");
    }
    return keys;
  };

  const [openKeys, setOpenKeys] = useState(() => getOpenKeysFromPath(location.pathname));

  useEffect(() => {
    setOpenKeys(getOpenKeysFromPath(location.pathname));
  }, [location.pathname]);

  const getSelectedKeys = () => {
    const path = location.pathname;
    if (path === "/") return ["dashboard"];
    if (path.startsWith("/GetCustomer")) return ["customers"];
    if (path.startsWith("/GetProducts")) return ["products"];
    if (path.startsWith("/categories")) return ["categories"];
    if (path.startsWith("/GetUnit")) return ["units"];
    if (path === "/TableOrder" || path.startsWith("/TableOrder")) return ["orders"];
    if (path === "/HomeShop") return ["homeshop"];
    if (path === "/CartShop") return ["cartshop"];
    if (path === "/Stock") return ["stock"];
    if (path === "/Reports") return ["reports-item"];
    if (path === "/CategoryProductReport") return ["categoryProductReport"];
    return [];
  };

  const menuItems = [
    {
      key: "dashboard",
      icon: <AppstoreOutlined />,
      label: <Link to="/">{t("dashboard")}</Link>,
    },
    {
      key: "customers",
      icon: <UserOutlined />,
      label: <Link to="/GetCustomer">{t("customers")}</Link>,
    },
    {
      key: "products",
      icon: <GiftOutlined />,
      label: <Link to="/GetProducts">{t("products")}</Link>,
    },
    {
      key: "categories",
      icon: <TagsOutlined />,
      label: <Link to="/categories">{t("categories")}</Link>,
    },
    {
      key: "units",
      icon: <ApartmentOutlined />,
      label: <Link to="/GetUnit">{t("units")}</Link>,
    },
    {
      key: "orders",
      icon: <InboxOutlined />,
      label: <Link to="/TableOrder">{t("orders")}</Link>,
    },
    {
      key: "homeshop",
      icon: <ShopOutlined />,
      label: <Link to="/HomeShop">{t("homeShop")}</Link>,
    },
    {
      key: "cartshop",
      icon: (
        <Badge count={cartCount} size="small" offset={[4, 0]}>
          <ShoppingCartOutlined />
        </Badge>
      ),
      label: <Link to="/CartShop">{t("cartShop")}</Link>,
    },
    {
      key: "stock",
      icon: <BlockOutlined />,
      label: <Link to="/Stock">{t("stock")}</Link>,
    },
    {
      key: "reports",
      icon: <BarChartOutlined />,
      label: t("Reports"),
      children: [
        { key: "reports-item", label: <Link to="/Reports">{t("reports")}</Link> },
        {
          key: "categoryProductReport",
          label: <Link to="/CategoryProductReport">{t("Category Product Report")}</Link>,
        },
      ],
    },
  ];

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      width={260}
      collapsedWidth={72}
      className="app-sidebar"
      theme="dark"
      breakpoint="lg"
    >
      <div className="sidebar-brand">
        <Link to="/" className="sidebar-brand-link">
          <img src={Logo} alt="Velan" className="sidebar-logo" />
          {!collapsed && <span className="sidebar-brand-text">Velan</span>}
        </Link>
      </div>
      <Menu
        mode="inline"
        selectedKeys={getSelectedKeys()}
        openKeys={openKeys}
        onOpenChange={setOpenKeys}
        items={menuItems}
        className="sidebar-menu"
      />
    </Sider>
  );
};

export default Sidebar;
